// Shared helpers for money, sizes, colors and images.

// Store 10 (מרכז הרשת) is the only store whose orders go to Verifone (see api/rest.php agents_finish_cart).
export const MAIN_STORE = '10';
export const VAT_PERCENT = 18;

// 66.3 -> ₪66.30, 180 -> ₪180
export function money(n) {
	const v = Number(n) || 0;
	return '₪' + v.toLocaleString('he-IL', {
		minimumFractionDigits: Number.isInteger(v) ? 0 : 2,
		maximumFractionDigits: 2
	});
}

// Image URLs are saved with the server's domain; the files live in /temp/products on every server.
export function imgUrl(url) {
	if (!url) return '';
	const i = url.indexOf('/temp/products/');
	return i >= 0 ? url.slice(i) : url;
}

const LETTER_SIZES = { xxs: 1, xs: 2, s: 3, m: 4, l: 5, xl: 6, '2xl': 7, xxl: 7, '3xl': 8, xxxl: 8, '4xl': 9, xxxxl: 9, onesize: 10, os: 10 };

export function sizeRank(size) {
	const s = String(size ?? '').trim().toLowerCase();
	if (s === '') return 1e6;
	if (s in LETTER_SIZES) return LETTER_SIZES[s];
	const n = parseFloat(s);
	return isNaN(n) ? 1e6 - 1 : 100 + n;
}

export const bySize = (a, b) => sizeRank(a) - sizeRank(b) || String(a).localeCompare(String(b));

// Verifone color names (English or Hebrew) -> swatch color
const COLOR_HEX = [
	['שחור', '#1B1B1B'], ['לבן', '#F6F5F1'], ['כחול כהה', '#1F2A44'], ['כחול', '#2F5DA8'], ['ג\'ינס', '#4A6A8C'], ['גינס', '#4A6A8C'],
	['אפור', '#9A9A98'], ['ירוק', '#2E7D4F'], ['ורוד', '#E8A6B8'], ['סגול', '#6B4F8A'], ['צהוב', '#E8C547'], ['כתום', '#E07B2E'],
	['אדום', '#C0322B'], ['זהב', '#C9A54A'], ['כסף', '#C0C0C0'], ['טורקיז', '#3FB6B0'], ['אבן', '#B9B0A1'],
	['STONE', '#B9B0A1'], ['FISTUK', '#9DB27A'], ['PETROL', '#1F5560'], ['POWDER', '#E9C9C2'], ['AQUA', '#6FC7C9'], ['CHOCOLATE', '#4A2E22'], ['STEAL', '#8A9199'],
	['OFF WHITE', '#EFEBE1'], ['WHITE', '#F6F5F1'], ['CREAM', '#EFE6D2'], ['ECRU', '#E8DFC9'],
	['BLACK', '#1B1B1B'], ['SMOKE', '#6E6E6E'], ['CHARCOAL', '#3B3B3B'], ['GRAY', '#9A9A98'], ['GREY', '#9A9A98'], ['SILVER', '#C0C0C0'],
	['NAVY', '#1F2A44'], ['LT. BLUE', '#A9C7E3'], ['LIGHT BLUE', '#A9C7E3'], ['DENIM', '#4A6A8C'], ['BLUE', '#2F5DA8'], ['TURQUOISE', '#3FB6B0'],
	['BOTTLE', '#1F4D3A'], ['OLIVE', '#6B6B3A'], ['KHAKI', '#A89B6B'], ['MINT', '#B6E2CF'], ['GREEN', '#2E7D4F'],
	['SAND', '#CDB89A'], ['BEIGE', '#D8C7A8'], ['CAMEL', '#B8875A'], ['BROWN', '#6B4A33'], ['GOLD', '#C9A54A'],
	['BORDO', '#6E1F2E'], ['BURGUNDY', '#6E1F2E'], ['RED', '#C0322B'], ['PINK', '#E8A6B8'], ['PURPLE', '#6B4F8A'], ['LILAC', '#B8A2D6'],
	['ORANGE', '#E07B2E'], ['YELLOW', '#E8C547']
];

export function swatch(color) {
	const c = String(color || '').toUpperCase();
	for (const [name, hex] of COLOR_HEX) {
		if (c.includes(name)) return hex;
	}
	return '#D9D6CF';
}

export function timeAgo(minutes) {
	const m = Number(minutes);
	if (!isFinite(m) || m < 0) return '';
	if (m < 1) return 'עכשיו';
	if (m < 60) return `לפני ${Math.round(m)} דק׳`;
	const h = m / 60;
	if (h < 24) return `לפני ${Math.round(h)} שע׳`;
	return `לפני ${Math.round(h / 24)} ימים`;
}

export function cartTotals(items = []) {
	let units = 0;
	let total = 0;
	for (const i of items) {
		units += Number(i.quantity) || 0;
		// wholesale price; the customer's discount is not shown to agents (it is given at the warehouse)
		total += (Number(i.price) || 0) * (Number(i.quantity) || 0);
	}
	total = Math.round(total * 100) / 100;
	const beforeVat = Math.round(total / (1 + VAT_PERCENT / 100) * 100) / 100;
	return { units, total, beforeVat, vat: Math.round((total - beforeVat) * 100) / 100 };
}

export function formatDate(str) {
	if (!str) return '';
	const d = new Date(String(str).replace(' ', 'T'));
	if (isNaN(d)) return str;
	return d.toLocaleDateString('he-IL', { day: 'numeric', month: 'numeric', year: '2-digit' }) + ' · ' +
		d.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' });
}
